import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function LivresPersonnalisesPage() {
  const [selectedAge, setSelectedAge] = useState<string>('all');
  const [selectedTheme, setSelectedTheme] = useState<string>('all');

  const books = [
    {
      id: 1,
      name: 'L\'Aventure de Noël Magique',
      description: 'Votre enfant part à l\'aventure avec le Père Noël pour sauver Noël',
      price: '29.90',
      age: '3-8',
      theme: 'noel',
      pages: 24,
      bestseller: true,
      image: 'https://public.readdy.ai/ai/img_res/0b0a6284f28b76daaef0266ada3a448a.jpg magical Christmas storybook cover showing a child character flying with Santa Claus over a snowy village with twinkling lights, reindeer in the sky, warm festive colors, Pixar Disney animation style, simple clean background, enchanting holiday atmosphere, professional illustration quality&width=500&height=650&seq=xmasbook2&orientation=portrait',
    },
    {
      id: 2,
      name: 'Mission Spatiale Extraordinaire',
      description: 'Devenez astronaute et explorez les planètes avec des amis extraterrestres',
      price: '29.90',
      age: '5-10',
      theme: 'aventure',
      pages: 28,
      bestseller: false,
      image: 'https://readdy.ai/api/search-image?query=A space adventure storybook cover with a child astronaut character floating among colorful planets, friendly cute aliens, stars and rockets, vibrant cosmic colors, Pixar Disney style, simple gradient background, exciting atmosphere, professional quality illustration&width=500&height=650&seq=spacebook2&orientation=portrait',
    },
    {
      id: 3,
      name: 'Le Royaume Enchanté',
      description: 'Une aventure royale dans un château magique avec licornes et fées',
      price: '29.90',
      age: '3-8',
      theme: 'fantaisie',
      pages: 26,
      bestseller: true,
      image: 'https://readdy.ai/api/search-image?query=A princess kingdom storybook cover showing a child character in royal outfit standing in front of a magical castle with unicorns and fairies flying around, pastel colors, sparkles and magic, Pixar Disney style, simple clean background, enchanting fairytale atmosphere&width=500&height=650&seq=princessbook2&orientation=portrait',
    },
    {
      id: 4,
      name: 'Les Héros de la Jungle',
      description: 'Explorez la jungle tropicale et rencontrez des animaux extraordinaires',
      price: '29.90',
      age: '4-9',
      theme: 'aventure',
      pages: 24,
      bestseller: false,
      image: 'https://readdy.ai/api/search-image?query=A jungle adventure storybook cover with a child explorer character surrounded by friendly tropical animals like monkeys elephants and parrots, lush green vegetation, vibrant colors, Pixar Disney style, simple background, exciting atmosphere, professional illustration&width=500&height=650&seq=junglebook1&orientation=portrait',
    },
    {
      id: 5,
      name: 'Voyage Sous les Océans',
      description: 'Plongez dans les profondeurs marines et découvrez les trésors cachés',
      price: '29.90',
      age: '4-9',
      theme: 'aventure',
      pages: 26,
      bestseller: false,
      image: 'https://readdy.ai/api/search-image?query=An underwater adventure storybook cover showing a child character swimming with dolphins and colorful fish, coral reefs, treasure chest, beautiful blue ocean colors, Pixar Disney style, simple clean background, magical underwater atmosphere, professional quality&width=500&height=650&seq=oceanbook1&orientation=portrait',
    },
    {
      id: 6,
      name: 'Le Monde des Dinosaures',
      description: 'Remontez le temps et vivez des aventures avec les dinosaures',
      price: '29.90',
      age: '5-10',
      theme: 'aventure',
      pages: 28,
      bestseller: true,
      image: 'https://readdy.ai/api/search-image?query=A dinosaur adventure storybook cover with a child character exploring prehistoric world with friendly dinosaurs, volcanic landscape, vibrant colors, Pixar Disney style, simple background, exciting atmosphere, professional illustration quality&width=500&height=650&seq=dinobook1&orientation=portrait',
    },
    {
      id: 7,
      name: 'La Fête d\'Anniversaire Magique',
      description: 'Une histoire spéciale pour célébrer l\'anniversaire de votre enfant',
      price: '29.90',
      age: '3-8',
      theme: 'anniversaire',
      pages: 24,
      bestseller: false,
      image: 'https://readdy.ai/api/search-image?query=A birthday celebration storybook cover showing a child character at a magical party with balloons cake presents and friends, bright cheerful colors, Pixar Disney style, simple clean background, festive joyful atmosphere, professional quality illustration&width=500&height=650&seq=bdaybook1&orientation=portrait',
    },
    {
      id: 8,
      name: 'Les Gardiens de la Forêt',
      description: 'Protégez la nature avec les créatures magiques de la forêt',
      price: '29.90',
      age: '4-9',
      theme: 'fantaisie',
      pages: 26,
      bestseller: false,
      image: 'https://readdy.ai/api/search-image?query=A magical forest storybook cover with a child character meeting fairy tale creatures like elves and magical animals among tall trees, soft green colors, sparkles, Pixar Disney style, simple background, enchanting atmosphere, professional illustration&width=500&height=650&seq=forestbook1&orientation=portrait',
    },
    {
      id: 9,
      name: 'Super-Héros en Mission',
      description: 'Devenez un super-héros et sauvez la ville des méchants',
      price: '29.90',
      age: '5-10',
      theme: 'aventure',
      pages: 28,
      bestseller: true,
      image: 'https://readdy.ai/api/search-image?query=A superhero storybook cover showing a child character in colorful superhero costume flying over a city, action pose, vibrant colors, Pixar Disney style, simple clean background, exciting heroic atmosphere, professional quality illustration&width=500&height=650&seq=herobook1&orientation=portrait',
    },
  ];

  const themes = [
    { id: 'all', name: 'Tous les thèmes', icon: 'ri-apps-line' },
    { id: 'aventure', name: 'Aventure', icon: 'ri-compass-3-line' },
    { id: 'fantaisie', name: 'Fantaisie', icon: 'ri-magic-line' },
    { id: 'noel', name: 'Noël', icon: 'ri-gift-line' },
    { id: 'anniversaire', name: 'Anniversaire', icon: 'ri-cake-3-line' },
  ];

  const ageGroups = [
    { id: 'all', name: 'Tous les âges' },
    { id: '3-8', name: '3-8 ans' },
    { id: '4-9', name: '4-9 ans' },
    { id: '5-10', name: '5-10 ans' },
  ];

  const filteredBooks = books.filter((book) => {
    const ageMatch = selectedAge === 'all' || book.age === selectedAge;
    const themeMatch = selectedTheme === 'all' || book.theme === selectedTheme;
    return ageMatch && themeMatch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"></div>
        
        {/* Decorative Elements */}
        <div className="absolute top-20 right-10 text-6xl opacity-20">📚</div>
        <div className="absolute bottom-20 left-10 text-5xl opacity-20">✨</div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 rounded-full mb-6">
                <span className="text-xl">📖</span>
                <span className="font-quicksand font-semibold text-gray-800">
                  Livres Numériques Personnalisés
                </span>
              </div>

              <h1 className="text-6xl font-fredoka font-bold text-gray-900 mb-6 leading-tight">
                Votre enfant devient le{' '}
                <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                  Des histoires personnalisées, riches en émotions
                </span>
              </h1>

              <p className="text-xl font-quicksand text-gray-600 mb-8 leading-relaxed">
                Nos ebooks sont de véritables livres illustrés, conçus pour stimuler la lecture, l’imagination et la confiance en soi.
Chaque page est pensée pour émerveiller :
              </p>

              {/* Features */}
              <div className="space-y-4 mb-8">
                {[
                  { icon: 'ri-user-heart-line', text: 'illustrations douces et colorées,' },
                  { icon: 'ri-file-pdf-line', text: 'narration bienveillante,' },
                  { icon: 'ri-time-line', text: 'scénarios adaptés à l’âge de l’enfant,' },
                  { icon: 'ri-gift-line', text: 'personnalisation complète du héros. Votre enfant ne lit plus simplement une histoire… il vit son histoire.' },
                ].map((feature, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
                    className="flex items-center gap-3"
                  >
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-blue/10 rounded-full flex-shrink-0">
                      <i className={`${feature.icon} text-primary-blue text-lg`}></i>
                    </div>
                    <span className="font-quicksand text-gray-700">{feature.text}</span>
                  </motion.div>
                ))}
              </div>

              <Link
                to="#livres"
                className="inline-flex items-center gap-2 px-8 py-4 bg-gray-900 text-white font-quicksand font-bold rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Découvrir nos livres</span>
                <i className="ri-arrow-down-line"></i>
              </Link>
            </motion.div>

            {/* Right Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-5xl overflow-hidden shadow-soft-lg">
                <div className="w-full h-[600px]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A collection of colorful personalized children storybooks floating in magical arrangement with sparkles and stars around them, various book covers showing different adventures, Pixar Disney animation style, vibrant colors, simple gradient background, enchanting atmosphere, professional quality illustration&width=700&height=900&seq=booksheromainimage&orientation=portrait"
                    alt="Livres personnalisés"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Comment créer votre livre ?
            </h2>
            <p className="text-xl font-quicksand text-gray-600">
              Un processus simple et rapide en 4 étapes
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                number: 1,
                icon: 'ri-book-open-line',
                title: 'Choisissez l\'histoire',
                description: 'Sélectionnez le thème qui plaira à votre enfant',
              },
              {
                number: 2,
                icon: 'ri-edit-box-line',
                title: 'Personnalisez',
                description: 'Ajoutez le nom, l\'âge et l\'apparence de votre enfant',
              },
              {
                number: 3,
                icon: 'ri-shopping-cart-line',
                title: 'Commandez',
                description: 'Paiement sécurisé en quelques clics',
              },
              {
                number: 4,
                icon: 'ri-mail-send-line',
                title: 'Recevez',
                description: 'Votre livre PDF arrive par email ',
              },
            ].map((step, index) => (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="relative"
              >
                <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 text-center h-full">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gradient-to-br from-primary-blue to-purple-600 rounded-full shadow-colored-blue">
                    <span className="text-2xl font-fredoka font-bold text-white">
                      {step.number}
                    </span>
                  </div>
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center">
                    <i className={`${step.icon} text-4xl text-primary-blue`}></i>
                  </div>
                  <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                    {step.title}
                  </h3>
                  <p className="font-quicksand text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Books Catalog Section */}
      <section id="livres" className="py-20 bg-neutral-lighter">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Notre Collection de Livres
            </h2>
            <p className="text-xl font-quicksand text-gray-600">
              Des histoires magiques pour tous les âges et tous les goûts
            </p>
          </div>

          {/* Filters */}
          <div className="mb-12">
            {/* Theme Filter */}
            <div className="mb-6">
              <h3 className="text-lg font-fredoka font-bold text-gray-900 mb-4">
                Thèmes
              </h3>
              <div className="flex flex-wrap gap-3">
                {themes.map((theme) => (
                  <button
                    key={theme.id}
                    onClick={() => setSelectedTheme(theme.id)}
                    className={`px-6 py-3 rounded-full font-quicksand font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2 ${
                      selectedTheme === theme.id
                        ? 'bg-gray-900 text-white shadow-soft'
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    <i className={`${theme.icon} text-lg`}></i>
                    <span>{theme.name}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Age Filter */}
            <div>
              <h3 className="text-lg font-fredoka font-bold text-gray-900 mb-4">
                Âge recommandé
              </h3>
              <div className="flex flex-wrap gap-3">
                {ageGroups.map((age) => (
                  <button
                    key={age.id}
                    onClick={() => setSelectedAge(age.id)}
                    className={`px-6 py-3 rounded-full font-quicksand font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      selectedAge === age.id
                        ? 'bg-primary-blue text-white shadow-colored-blue'
                        : 'bg-white text-gray-700 hover:bg-gray-100'
                    }`}
                  >
                    {age.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Books Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredBooks.map((book, index) => (
              <motion.div
                key={book.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="group bg-white rounded-3xl overflow-hidden shadow-soft hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2">
                  {/* Image */}
                  <div className="relative w-full h-96 overflow-hidden">
                    <img
                      src={book.image}
                      alt={book.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {book.bestseller && (
                      <div className="absolute top-4 right-4 px-3 py-1 bg-primary-yellow text-gray-900 text-xs font-quicksand font-bold rounded-full shadow-soft">
                        ⭐ Bestseller
                      </div>
                    )}
                    <div className="absolute bottom-4 left-4 px-3 py-1 bg-white/90 backdrop-blur-sm text-gray-900 text-sm font-quicksand font-semibold rounded-full">
                      {book.pages} pages
                    </div>
                  </div>

                  {/* Content */}
                  <div className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="px-3 py-1 bg-primary-blue/10 text-primary-blue text-xs font-quicksand font-bold rounded-full">
                        {book.age} ans
                      </span>
                    </div>
                    <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-2">
                      {book.name}
                    </h3>
                    <p className="font-quicksand text-gray-600 text-sm mb-4 leading-relaxed">
                      {book.description}
                    </p>
                    <div className="flex items-center justify-between mb-4">
                      <div>
                        <div className="text-xs font-quicksand text-gray-500 mb-1">
                          À partir de
                        </div>
                        <div className="text-3xl font-fredoka font-bold text-gray-900">
                          {book.price}€
                        </div>
                      </div>
                    </div>
                    <Link
                      to={`/produit/${book.id}`}
                      className="block w-full px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full group-hover:bg-primary-blue transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                    >
                      Personnaliser ce livre
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {filteredBooks.length === 0 && (
            <div className="text-center py-20">
              <div className="text-6xl mb-4">📚</div>
              <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-2">
                Aucun livre trouvé
              </h3>
              <p className="font-quicksand text-gray-600">
                Essayez de modifier vos filtres
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              Pourquoi choisir nos livres ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-heart-3-line',
                title: 'Créé avec amour',
                description: 'Chaque livre est conçu avec soin par nos illustrateurs professionnels',
                gradient: 'from-pink-400 to-red-500',
              },
              {
                icon: 'ri-star-smile-line',
                title: 'Qualité premium',
                description: 'Illustrations haute résolution, parfaites pour l\'impression',
                gradient: 'from-yellow-400 to-orange-500',
              },
              {
                icon: 'ri-user-smile-line',
                title: 'Personnalisation unique',
                description: 'Votre enfant se reconnaîtra vraiment dans l\'histoire',
                gradient: 'from-blue-400 to-purple-600',
              },
              {
                icon: 'ri-book-read-line',
                title: 'Histoires captivantes',
                description: 'Des récits qui stimulent l\'imagination et la lecture',
                gradient: 'from-green-400 to-teal-600',
              },
              {
                icon: 'ri-printer-line',
                title: 'Prêt à imprimer',
                description: 'Format PDF optimisé pour une impression professionnelle',
                gradient: 'from-indigo-400 to-blue-600',
              },
              {
                icon: 'ri-gift-2-line',
                title: 'Cadeau mémorable',
                description: 'Un souvenir unique qui restera gravé à jamais',
                gradient: 'from-purple-400 to-pink-600',
              },
            ].map((benefit, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-3xl p-8 text-center"
              >
                <div className={`w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-gradient-to-br ${benefit.gradient} rounded-2xl shadow-soft`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                  {benefit.title}
                </h3>
                <p className="font-quicksand text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-primary-blue via-purple-600 to-primary-coral">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl font-fredoka font-bold text-white mb-6">
              Prêt à créer le livre de votre enfant ?
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Offrez-lui une histoire unique où il devient le héros
            </p>
            <Link
              to="#livres"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 font-quicksand font-bold text-lg rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Choisir un livre</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}